/* mm-cart — tiroir + page panier Mamilly. Prix toujours lus dans /cart.js. XHR uniquement (window.fetch est intercepté par une app). */
(function(){
  if(window.__mmCart)return;
  var root=document.querySelector('[data-mm-cart]');
  if(!root)return;
  window.__mmCart=1;
  var CFG;
  try{CFG=JSON.parse(root.querySelector('[data-mm-cart-config]').textContent);}catch(e){return;}
  var MODE=CFG.mode,G=CFG.gift,CAPES=CFG.capes||[],R=CFG.root||'/';
  if(R.charAt(R.length-1)!=='/')R+='/';
  var capeIds=CAPES.map(function(c){return c.id;});
  var RM=!!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches);
  var dlg=root.querySelector('[data-mm-cd]');
  function q(s,r){return (r||root).querySelector(s);}
  function qa(s,r){return [].slice.call((r||root).querySelectorAll(s));}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function fmt(c){
    var n=(Math.round(c)/100).toFixed(2),f=CFG.money||'{{amount_with_comma_separator}} \u20ac';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/,function(m,k){
      var v=n;if(k.indexOf('no_decimals')>-1)v=String(Math.round(c/100));
      if(k.indexOf('comma')>-1)v=v.replace('.',',');
      return v;
    }).replace(/<[^>]*>/g,'');
  }
  function img(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+w;}

  qa('[data-s-cta-btn] > span').forEach(function(s){s.textContent='Commander';});

  function req(method,url,body){
    return new Promise(function(res,rej){
      var x=new XMLHttpRequest();x.__mm=1;
      x.open(method,url,true);
      x.setRequestHeader('Accept','application/json');
      x.setRequestHeader('X-Requested-With','XMLHttpRequest');
      var isFd=typeof FormData!=='undefined'&&body instanceof FormData;
      if(body&&!isFd)x.setRequestHeader('Content-Type','application/json');
      x.onload=function(){var d=null;try{d=JSON.parse(x.responseText);}catch(e){}if(x.status>=200&&x.status<300)res(d);else rej(d||{status:x.status});};
      x.onerror=function(){rej({});};
      x.send(body?(isFd?body:JSON.stringify(body)):null);
    });
  }
  function getCart(){return req('GET',R+'cart.js?_='+Date.now());}

  function isGift(it){return it.variant_id===G.id||!!(it.properties&&it.properties._mm_gift);}
  function isCarrier(it){return !isGift(it)&&(it.product_type===CFG.carrierType||(CFG.carrierHandles||[]).indexOf(it.handle)>-1);}
  function isCape(it){return capeIds.indexOf(it.variant_id)>-1;}
  function sum(list){return list.reduce(function(a,i){return a+i.quantity;},0);}

  function syncGift(cart){
    var items=cart.items||[],c=sum(items.filter(isCarrier)),gl=items.filter(isGift),g=sum(gl);
    if(c===g&&gl.length<=1)return null;
    if(gl.length){var up={};gl.forEach(function(l,i){up[l.key]=i?0:c;});return req('POST',R+'cart/update.js',{updates:up});}
    if(c>0)return req('POST',R+'cart/add.js',{items:[{id:G.id,quantity:c,properties:{_mm_gift:'1'}}]});
    return null;
  }

  var hadGift=null,lastTotal=null,knownKeys=null;
  function refresh(open){
    return getCart().then(function(c){
      var p=syncGift(c);
      return p?p.then(getCart,getCart):c;
    }).then(function(c){render(c);if(open)openD();})
    .catch(function(){})
    .then(function(){root.classList.remove('is-loading');});
  }

  function splitTitle(it){
    var t=it.product_title||it.title||'',name=t,sub='';
    var m=t.split(/\s[\u2014\u2013-]\s/);
    if(m.length>1){name=m[0];sub=m.slice(1).join(' \u2013 ');}
    if(!sub&&it.variant_title&&it.variant_title!=='Default Title')sub=it.variant_title;
    if(sub&&isCarrier(it)&&!/^imprim/i.test(sub))sub='Imprim\u00e9 '+sub;
    return {name:name,sub:sub};
  }
  function lineHtml(it,isNew){
    var t=splitTitle(it),disc=(it.line_level_discount_allocations||[]).length>0&&it.original_line_price>it.final_line_price;
    var label='';
    if(disc){var a=it.line_level_discount_allocations[0],tt=a&&a.discount_application&&a.discount_application.title||'';label=/duo/i.test(tt)||!tt?'Prix duo':tt;}
    return '<div class="mm-cl'+(isNew?' is-new':'')+'" data-key="'+esc(it.key)+'" data-q-now="'+it.quantity+'">'+
      '<a class="mm-cl__img" href="'+esc(it.url)+'" tabindex="-1" aria-hidden="true">'+(it.image?'<img src="'+esc(img(it.image,176))+'" alt="" width="88" height="88" loading="lazy">':'')+'</a>'+
      '<div class="mm-cl__info"><a class="mm-cl__name" href="'+esc(it.url)+'">'+esc(t.name)+'</a>'+(t.sub?'<p class="mm-cl__var">'+esc(t.sub)+'</p>':'')+
      '<div class="mm-cl__ctrl"><div class="mm-qty" role="group" aria-label="Quantit\u00e9"><button type="button" data-q="-1" aria-label="Diminuer"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 12h12"/></svg></button><span>'+it.quantity+'</span><button type="button" data-q="1" aria-label="Augmenter"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M12 6v12M6 12h12"/></svg></button></div>'+
      '<button type="button" class="mm-cl__rm" data-rm>Retirer</button></div></div>'+
      '<div class="mm-cl__price">'+(disc?'<s>'+fmt(it.original_line_price)+'</s>':'')+'<span>'+fmt(it.final_line_price)+'</span>'+(disc?'<span class="mm-tag">'+esc(label)+'</span>':'')+'</div>'+
    '</div>';
  }
  function giftHtml(q,isNew){
    return '<div class="mm-cg'+(isNew?' is-new':'')+'">'+
      '<span class="mm-cg__img">'+(G.image?'<img src="'+esc(G.image)+'" alt="" width="64" height="64" loading="lazy">':'')+'</span>'+
      '<div><p class="mm-cg__t">Votre bo\u00eete cadeau Mamilly <svg class="mm-cg__bow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path pathLength="1" d="M12 11.5C9.6 8 5 6.6 5 9.2s4.6 3.2 7 2.3zM12 11.5c2.4-3.5 7-4.9 7-2.3s-4.6 3.2-7 2.3zM12 11.5l-3.5 7M12 11.5l3.5 7"/></svg></p>'+
      '<p class="mm-cg__s">Offerte avec votre porte-b\u00e9b\u00e9 \u00b7 pr\u00eate \u00e0 offrir'+(q>1?' \u00b7 \u00d7 '+q:'')+'</p></div>'+
      '<div class="mm-cg__p"><s>'+fmt(G.compare*q)+'</s><strong>Offerte</strong></div>'+
    '</div>';
  }
  function upsellHtml(inCart){
    var cards=CAPES.filter(function(c){return c.available&&c.price>0&&inCart.indexOf(c.id)<0;});
    if(!cards.length)return '';
    return '<section class="mm-cu" aria-labelledby="mm-cu-t-'+MODE+'"><div class="mm-cu__head"><div><h3 class="mm-cu__t" id="mm-cu-t-'+MODE+'">Compl\u00e9tez votre portage</h3></div>'+
      (cards.length>2?'<div class="mm-cu__nav"><button type="button" data-cu-prev aria-label="Capes pr\u00e9c\u00e9dentes"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 6l-6 6 6 6"/></svg></button><button type="button" data-cu-next aria-label="Capes suivantes"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 6l6 6-6 6"/></svg></button></div>':'')+
      '</div><p class="mm-cu__s"><strong>\u221220 \u20ac sur une cape</strong> pour tout porte-b\u00e9b\u00e9 achet\u00e9.</p><div class="mm-cu__track" data-cu-track>'+
      cards.map(function(c){
        var duo=Math.max(0,c.price-2000),gain=c.price-duo;
        return '<article class="mm-cu__card" data-cape="'+c.id+'"><a class="mm-cu__img" href="'+esc(c.url)+'" tabindex="-1" aria-hidden="true">'+(c.image?'<img src="'+esc(c.image)+'" alt="" loading="lazy">':'')+'</a>'+
          '<p class="mm-cu__n">'+esc(c.name)+'</p><p class="mm-cu__u">'+esc(c.use)+'</p>'+
          '<p class="mm-cu__p"><s aria-label="Prix seule">'+fmt(c.price)+'</s><span>'+fmt(duo)+'</span></p>'+
          '<p class="mm-cu__save">Vous \u00e9conomisez '+fmt(gain).replace(/,00(?=\D|$)/,'')+'</p>'+
          '<button type="button" class="mm-cu__add" data-add-cape="'+c.id+'" aria-label="Ajouter '+esc(c.name)+' au panier">+ Ajouter</button></article>';
      }).join('')+'</div></section>';
  }

  function render(c){
    var items=c.items||[],gifts=items.filter(isGift),others=items.filter(function(i){return !isGift(i);});
    var carriers=sum(others.filter(isCarrier)),capesQ=sum(others.filter(isCape)),gq=sum(gifts);
    var empty=!items.length;
    root.classList.toggle('is-empty',empty);
    var cnt=q('[data-c-count]');if(cnt)cnt.textContent=c.item_count?'('+c.item_count+(c.item_count>1?' articles)':' article)'):'';
    qa('#cart-icon-bubble .cart-count, .cart-count-drawer',document).forEach(function(el){var n=el.firstChild;if(n&&n.nodeType===3)n.nodeValue=c.item_count;});
    var newKeys=items.map(function(i){return i.key;});
    var linesHtml=others.map(function(i){return lineHtml(i,knownKeys&&knownKeys.indexOf(i.key)<0&&!RM);}).join('');
    if(gq>0)linesHtml+=giftHtml(gq,hadGift===false);
    q('[data-c-lines]').innerHTML=linesHtml;
    q('[data-c-empty]').hidden=!empty;
    var inCart=others.filter(isCape).map(function(i){return i.variant_id;});
    q('[data-c-upsell]').innerHTML=(carriers>capesQ)?upsellHtml(inCart):'';
    var sub=q('[data-s-sub]'),save=q('[data-s-save]'),saveRow=q('[data-s-save-row]'),tot=q('[data-s-total]'),split=q('[data-s-split]'),live=q('[data-s-live]');
    var orig=c.original_total_price!=null?c.original_total_price:c.items_subtotal_price;
    var d=c.total_discount||0;
    sub.textContent=fmt(orig);
    var subRow=sub.parentNode;if(subRow)subRow.hidden=d<=0;
    saveRow.hidden=d<=0;save.textContent='\u2212'+fmt(d);
    tot.textContent=fmt(c.total_price);
    split.textContent=fmt(Math.round(c.total_price/3));
    if(lastTotal!==null&&lastTotal!==c.total_price){tot.classList.remove('is-bump');void tot.offsetWidth;tot.classList.add('is-bump');live.textContent='Total mis \u00e0 jour : '+fmt(c.total_price);}
    lastTotal=c.total_price;hadGift=gq>0;knownKeys=newKeys;
    var err=q('[data-c-err]');if(err&&!err.__keep)err.hidden=true;if(err)err.__keep=false;
  }
  function showErr(e){var el=q('[data-c-err]');if(!el)return;el.textContent=(e&&(e.description||e.message))||'Une erreur est survenue, merci de r\u00e9essayer.';el.hidden=false;el.__keep=true;}

  function change(line,qty){
    line.classList.add('is-busy');
    return req('POST',R+'cart/change.js',{id:line.getAttribute('data-key'),quantity:qty}).catch(showErr).then(function(){return refresh(false);});
  }

  root.addEventListener('click',function(e){
    var t=e.target;
    if(dlg&&t===dlg){closeD();return;}
    if(t.closest('[data-c-close]')){closeD();return;}
    var b=t.closest('[data-q]');
    if(b){var l=b.closest('[data-key]');var n=+l.getAttribute('data-q-now')+(+b.getAttribute('data-q'));change(l,Math.max(0,n));return;}
    if(t.closest('[data-rm]')){change(t.closest('[data-key]'),0);return;}
    var add=t.closest('[data-add-cape]');
    if(add){
      var card=add.closest('.mm-cu__card');add.disabled=true;
      if(card&&!RM)card.classList.add('is-collapsing');
      req('POST',R+'cart/add.js',{items:[{id:+add.getAttribute('data-add-cape'),quantity:1}]}).catch(function(er){showErr(er);if(card)card.classList.remove('is-collapsing');add.disabled=false;}).then(function(){setTimeout(function(){refresh(false);},RM?0:260);});
      return;
    }
    var nav=t.closest('[data-cu-prev],[data-cu-next]');
    if(nav){var tr=q('[data-cu-track]');if(tr)tr.scrollBy({left:(nav.hasAttribute('data-cu-next')?1:-1)*164,behavior:RM?'auto':'smooth'});}
  });

  var lastFocus=null,closing=false;
  function openD(){
    if(!dlg||dlg.open)return;
    lastFocus=document.activeElement;
    dlg.showModal();document.documentElement.classList.add('mm-cd-lock');
    var x=q('[data-c-close]');if(x)try{x.focus({preventScroll:true});}catch(e){}
  }
  function closeD(){
    if(!dlg||!dlg.open||closing)return;
    if(RM){dlg.close();return;}
    closing=true;dlg.classList.add('is-closing');
    setTimeout(function(){dlg.classList.remove('is-closing');closing=false;dlg.close();},260);
  }
  if(dlg){
    dlg.addEventListener('cancel',function(e){e.preventDefault();closeD();});
    dlg.addEventListener('close',function(){document.documentElement.classList.remove('mm-cd-lock');if(lastFocus&&lastFocus.focus)try{lastFocus.focus({preventScroll:true});}catch(e){}});
  }

  function deliveryText(){
    var parts={};
    try{new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hour12:false}).formatToParts(new Date()).forEach(function(p){parts[p.type]=p.value;});}catch(e){var n0=new Date();parts={year:n0.getFullYear(),month:n0.getMonth()+1,day:n0.getDate(),hour:n0.getHours()};}
    var d=new Date(Date.UTC(+parts.year,+parts.month-1,+parts.day)),h=(+parts.hour)%24,w=d.getUTCDay(),n=+CFG.days||5;
    if(w>0&&w<6&&h>=(+CFG.cutoff))n+=1;
    while(n>0){d.setUTCDate(d.getUTCDate()+1);var wd=d.getUTCDay();if(wd!==0&&wd!==6)n--;}
    var J=['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'],M=['janvier','f\u00e9vrier','mars','avril','mai','juin','juillet','ao\u00fbt','septembre','octobre','novembre','d\u00e9cembre'];
    var day=d.getUTCDate();
    return J[d.getUTCDay()]+' '+(day===1?'1er':day)+' '+M[d.getUTCMonth()];
  }
  qa('[data-c-date]').forEach(function(el){el.textContent=deliveryText();});

  function closeTheme(){qa('.minicart__wrapper .close-cart-button',document).forEach(function(b){try{b.click();}catch(e){}});}
  function isCartLink(a){try{var u=new URL(a.getAttribute('href'),location.href);return u.origin===location.origin&&/\/cart\/?$/.test(u.pathname);}catch(e){return false;}}
  if(MODE==='drawer'){
    document.body.classList.add('mm-cart-on');
    window.addEventListener('click',function(e){
      var a=e.target.closest&&e.target.closest('a[href],[data-mm-cart-open]');
      if(!a||root.contains(a))return;
      if(a.hasAttribute('data-mm-cart-open')||(a.tagName==='A'&&isCartLink(a))){
        e.preventDefault();e.stopImmediatePropagation();
        openD();refresh(false);
      }
    },true);
    window.addEventListener('submit',function(e){
      var f=e.target;
      if(!f||f.tagName!=='FORM'||root.contains(f))return;
      var act=f.getAttribute('action')||'';
      if(!/\/cart\/add/.test(act))return;
      e.preventDefault();e.stopImmediatePropagation();
      var btn=f.querySelector('[type="submit"]');
      if(btn){btn.disabled=true;btn.setAttribute('aria-busy','true');}
      req('POST',R+'cart/add.js',new FormData(f)).catch(function(er){showErr(er);}).then(function(){return refresh(true);}).then(function(){if(btn){btn.disabled=false;btn.removeAttribute('aria-busy');}});
    },true);
    var ext=function(){setTimeout(function(){closeTheme();refresh(true);},80);};
    var XO=XMLHttpRequest.prototype.open,XS=XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open=function(m,u){this.__mmu=u;return XO.apply(this,arguments);};
    XMLHttpRequest.prototype.send=function(){var x=this;if(!x.__mm&&/\/cart\/add/.test(String(x.__mmu||''))){x.addEventListener('load',function(){if(x.status>=200&&x.status<300)ext();});}return XS.apply(this,arguments);};
    if(window.fetch){var F=window.fetch;window.fetch=function(i){var u=typeof i==='string'?i:(i&&i.url)||'';var p=F.apply(this,arguments);if(/\/cart\/add/.test(u)&&p&&p.then){p.then(function(r){if(r&&r.ok)ext();},function(){});}return p;};}
    window.MamillyCart={open:function(){openD();refresh(false);},close:closeD,refresh:refresh};
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){refresh(false);});else refresh(false);
})();
